// extracted by mini-css-extract-plugin
module.exports = {"blogListTitle":"BlogList_blogListTitle__M6a__","list":"BlogList_list__BKsFl"};